import { BiPhoneCall } from "react-icons/bi";
import { GoMail } from "react-icons/go";

import Workflow from "./workflow";
// Istanziazione fuori dal componente per evitare la ricreazione ad ogni render

export default function Home() {



  return (
    <div className="flex-col p-4 pt-0 xl:pl-20 xl:pr-20 items-center justify-center ">
      <h1 className="text-4xl font-bold text-center p-4 ">Progettazione, Precisione, Pulizia</h1>
      <div className="relative w-full bg-cover bg-center rounded-xl h-128 sm:h-144" style={{ backgroundImage: `url('./images/immagine1.jpg')` }}>
        <div className="absolute inset-0 bg-black bg-opacity-65 rounded-xl"></div>
        
        <div className="absolute left-0 top-0 p-8 font-medium text-center sm:text-left ">
          <p className="text-lg text-white ">Il nostro obiettivo è fornire prodotti di qualità e un servizio eccellente.</p>
          <p className="text-white">Contattaci e richiedi un preventivo gratuito</p>
        </div>

        <div className="absolute flex flex-col items-center justify-center  w-full h-full">
                <a href="/richiedi-preventivo">
                <div className='bg-white rounded-lg shadow-lg px-6 py-3 text-center'>
                    <p className="text-center text-logo-color2 text-lg font-bold">Richiedi un preventivo!</p>
                
                </div>
                </a>
               
              </div>

        <div className="absolute w-full flex bottom-0 sm:w-fit sm:right-0  text-white text-lg sm:text-xl font-medium h-fit flex-col items-end p-8">
          <a href="tel:3934308604" className="flex justify-center items-center p-1"><BiPhoneCall />&nbsp;Davide: +39 393 430 8604</a>
          <a href="tel:3421396350" className="flex justify-center items-center p-1"><BiPhoneCall />&nbsp;Matteo: +39 342 139 6350</a>
          <a href="mailto:info@dotserramenti.it" className="flex justify-center items-center">
            <div className="flex items-center">
              <GoMail /> &nbsp;Email:
            </div>
            <span >&nbsp;info@dotserramenti.it</span>
          </a>
        </div>


      </div>

      <div className="mt-8">
        <h1 className="text-2xl text-center font-semibold">Il nostro flusso di lavoro:</h1>
        <Workflow />
      </div>

    </div>
  );
}
